import type {DataMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import type {WandbArtifactCollectionPart} from '../../../agentChat/store/thread';
import {ArtifactCollectionPill} from '../../ArtifactOverview/ArtifactCollectionPill';

/**
 * ArtifactCollectionMentionPart renders an artifact collection mention as an
 * inline pill.
 */
export const ArtifactCollectionMentionPart: DataMessagePartComponent<
  WandbArtifactCollectionPart
> = ({data}) => <ArtifactCollectionPill collectionId={data.collectionId} />;
